export default {
  NEW_BOOKINGS_START_SEARCH: 'NEW_BOOKINGS_START_SEARCH',
  NEW_BOOKINGS_FAILURE_SEARCH : 'NEW_BOOKINGS_FAILURE_SEARCH',
  NEW_BOOKINGS_SUCCESS_SEARCH : 'NEW_BOOKINGS_SUCCESS_SEARCH',
  NEW_BOOKINGS_UPDATED_FILTERS : 'NEW_BOOKINGS_UPDATED_FILTERS',
  NEW_BOOKINGS_UPDATED_COLS_FILTERS : 'NEW_BOOKINGS_UPDATED_COLS_FILTERS',
  NEW_BOOKINGS_SELECT_BOOKING : 'NEW_BOOKINGS_SELECT_BOOKING',
  NEW_BOOKINGS_RESULT_SUCCESS_SEARCH: 'NEW_BOOKINGS_RESULT_SUCCESS_SEARCH',
  NEW_BOOKINGS_RESET_ALL_FILTERS: 'NEW_BOOKINGS_RESET_ALL_FILTERS'
}